<template>
  <!--  <el-dialog :visible.sync="showDialog" @close="closeDialog">1233</el-dialog>-->
  <div class="sn-bs-viewer" v-if="showDialog" @click="closeDialog">
    <el-carousel
      class="sn-bs-viewer__carousel"
      indicator-position="outside"
      :autoplay="false"
      :initial-index="initialIndex"
    >
      <el-carousel-item
        class="sn-bs-viewer__carousel-item"
        v-for="(item, index) in imgList"
        :key="index"
      >
        <img
          class="sn-bs-viewer__pic"
          @click="(e) => e.stopPropagation()"
          :src="item"
          alt=""
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "BsPreviewPic",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    initialIndex: {
      type: Number,
      default: 0,
    },
    imgUrlData: {
      type: [String, Array],
      required: true,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    imgList() {
      return typeof this.imgUrlData === "string"
        ? [this.imgUrlData]
        : this.imgUrlData;
    },
  },
  async mounted() {
    await this.appendDom();
  },
  methods: {
    // 挂载元素到 body 节点
    appendDom() {
      this.$nextTick(() => {
        const body = document.querySelector("body");
        if (body.append) {
          body.append(this.$el);
        } else {
          body.appendChild(this.$el);
        }
      });
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
@include bs(viewer) {
  @include utils-full-box();
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1999;
  background: rgba(0, 0, 0, 0.5);

  @include e(carousel) {
    @include utils-full-box();
  }

  @include e(carousel-item) {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @include e(pic) {
    max-width: 90vw;
    max-height: 90vh;
  }
}
</style>
<style lang="scss">
.sn-bs-viewer {
  @include be(carousel) {
    @include meb($element: container) {
      width: 90%;
      height: calc(100% - 26px);
      margin-left: 5%;

      @include meb($element: arrow) {
        width: 60px;
        height: 60px;
        font-size: 40px;
      }
    }
  }
}
</style>
